/*
 * Widget Templates
 * (Handlebars)
 *
 */
import './utils/lib/handlebars-helpers';
Gryphon = Gryphon || {};
Gryphon.templates = {
  address: require('./modules/Address/address.hbs'),
  audio: require('./modules/Audio/audio.hbs'),
  calendar: require('./modules/Calendar/calendar.hbs'),
  'card-sort': require('./modules/Cardsort/card-sort.hbs'),
  'cardsort-skinny': require('./modules/Cardsort/cardsort-skinny.hbs'),
  colorpicker: require('./modules/Colorpicker/colorpicker.hbs'),
  'displaymax-required-message': require('./components/DisplayMaxRequiredMessage/displaymax-required-message.hbs'),
  dropdown: require('./modules/Dropdown/dropdown.hbs'),
  'dyngrid-check': require('./modules/Dyngrid/dyngrid-check.hbs'),
  dyngrid: require('./modules/Dyngrid/dyngrid.hbs'),
  404: require('./components/NotFound/404.hbs'),
  'free-text': require('./modules/FreeText/free-text.hbs'),
  grid: require('./modules/Grid/grid.hbs'),
  'grid-cell-input': require('./components/GridCellInput/_grid-cell-input.hbs'),
  'grid-skinny': require('./modules/Grid/grid-skinny.hbs'),
  'grid-wide': require('./modules/Grid/grid-wide.hbs'),
  'image-highlight': require('./modules/ImageHighlight/image-highlight.hbs'),
  'imagemap-multiple': require('./modules/ImagemapMultiple/imagemap-multiple.hbs'),
  'imagemap-single': require('./modules/ImagemapSingle/imagemap-single.hbs'),
  matrix: require('./modules/Matrix/matrix.hbs'),
  multiple: require('./modules/SingleMultiple/multiple.hbs'),
  'multiple-colorpicker': require('./modules/SingleMultipleColorpicker/multiple-colorpicker.hbs'),
  open: require('./modules/Open/open.hbs'),
  open_entry: require('./modules/Open/open_entry.hbs'),
  open_inputarea: require('./modules/Open/open_inputarea.hbs'),
  open_trailer: require('./modules/Open/open_trailer.hbs'),
  placement: require('./modules/Placement/placement.hbs'),
  popup: require('./modules/Popup/popup.hbs'),
  rank: require('./modules/Rank/rank.hbs'),
  rank_skinny_dk: require('./modules/Rank/rank_skinny_dk.hbs'),
  rank_skinny_modal: require('./modules/Rank/rank_skinny_modal.hbs'),
  rank_skinny_placement: require('./modules/Rank/rank_skinny_placement.hbs'),
  rank_skinny_selection: require('./modules/Rank/rank_skinny_selection.hbs'),
  rank_viewcontainer: require('./modules/Rank/rank_viewcontainer.hbs'),
  rank_wide_dk: require('./modules/Rank/rank_wide_dk.hbs'),
  rank_wide_placement: require('./modules/Rank/rank_wide_placement.hbs'),
  rank_wide_selection: require('./modules/Rank/rank_wide_selection.hbs'),
  registration: require('./modules/Registration/registration.hbs'),
  'response-button': require('./components/ResponseButton/_response-button.hbs'),
  'response-item': require('./components/ResponseItem/_response-item.hbs'),
  rule: require('./modules/Rule/rule.hbs'),
  'rule-partial': require('./modules/Rule/rule-partial.hbs'),
  'dk-partial': require('./components/DkPartial/dk-partial.hbs'),
  scale: require('./modules/Scale/scale.hbs'),
  single: require('./modules/SingleMultiple/single.hbs'),
  'single-colorpicker': require('./modules/SingleMultipleColorpicker/single-colorpicker.hbs'),
  'text-highlight': require('./modules/TextHighlight/text-highlight.hbs'),
  thermometer: require('./modules/Thermometer/thermometer.hbs'),
  upload: require('./modules/Upload/upload.hbs'),
  video: require('./modules/Video/video.hbs'),
  'video-dial': require('./modules/VideoDial/video-dial.hbs'),
  captcha: require('./modules/Captcha/captcha.hbs'),
  'preview-debug-panel': require('./components/PreviewDebugPanel/preview-debug-panel.hbs'),
};
